<div class="container py-4 text-primary" *transloco="let t">
  <div class="row">
    <div class="col">

      @if (showCaptcha()) {

        <p>
          Bienvenue sur hopla. Avant de te donner l'accès à <i>{{ host().name }}</i>, vérifions en un clic que tu es bien humain.
        </p>

        <form [formGroup]="captchaForm">
          <div class="alert alert-warning mt-2" role="alert">
            <h4 class="alert-heading">
              {{ t('auth.validateEmail.CaptchaTitle') }}
            </h4>
            <p class="my-2">
              {{ t('auth.validateEmail.CaptchaMsg') }}
              <app-altcha formControlName="captcha" class="my-1" (onVerified)="validateCaptcha()"/>
            </p>
          </div>
        </form>
      }

      @if (showInvalidLink()) {
        <div class="alert alert-danger mt-2" role="alert">
          <p class="my-2">
            Ce lien n'est pas valide ou a expiré.
          </p>
        </div>
      }

      @if (captchaOk()) {
        <p>
          Parfait! Tu peux maintenant rejoindre <i>{{ host().name }}</i>, ce qui te permettra de présenter ton organisation et ses activités à la population:
        </p>
        <ul>
          <li>Infos pratiques de vos activités: horaires, lieu, audience, photo, etc.</li>
          <li>Profil public de {{ host().name }}</li>
          <li>Et bénéficie de la promotion continue des loisirs de hopla</li>
        </ul>

        @if (validating()) {
          <app-spinner [message]="'Validation en cours...'"></app-spinner>
        }

        @if (validationError()) {
          <div class="alert alert-danger mt-2" role="alert">
            <h4 class="alert-heading">
              Nous n'avons pas pu valider ton inscription.
            </h4>
            <p>Besoin d'aide? contacte notre support.</p>
          </div>
        }

        @if (validationOk()) {
          <div class="alert alert-success mt-2" role="alert">
            <h4 class="alert-heading">
              Nous avons validé ton inscription.
            </h4>
            <p>Nous te redirigeons vers ton activité...</p>
          </div>
        }

        <p class="text-end">
          <app-contact-support></app-contact-support>
          <button class="btn btn-primary" (click)="validateJoin()" [disabled]="disableJoinButton()">
            Rejoindre {{ host().name }}
            <lucide-icon [img]="icons.join"></lucide-icon>
          </button>
        </p>
      }
    </div>
  </div>
</div>

